import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { requestCCApi } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

export const useDeleteScheduleLocationExclusions = () => {
  return useMutation({
    mutationFn: deleteScheduleLocationExclusions,
    onSuccess() {
      queryClient.invalidateQueries(
        queryKeys.getCalendarEvents.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.getCalendarSidebarDetails.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.scheduleOverview.invalidateAll());
      queryClient.invalidateQueries(queryKeys.scheduleList.invalidateAll());
      queryClient.invalidateQueries(queryKeys.schedules.invalidateAll());
    },
  });
};

const deleteScheduleLocationExclusions = async ({
  locationCode,
  previousLocationGroups,
}: {
  locationCode: string;
  previousLocationGroups?: number[];
}) => {
  const url =
    `/scheduleLocationExclusions` +
    `?location_code=${locationCode}` +
    (previousLocationGroups
      ? `&location_group_id.list=${previousLocationGroups.join('|')}`
      : '');

  const response = await requestCCApi({
    url: url,
    method: 'DELETE',
  });

  return response;
};
